import React, { FunctionComponent, PropsWithChildren } from 'react';
import * as styles from './section.module.scss';
import { mergeClasses } from '../../../util/style';
import { PageWidth } from '../PageWidth';

export enum SectionVariant {
    Gray = 'gray',
    White = 'white',
    Green = 'green',
    DarkGreen = 'darkgreen',
}

export enum SectionSpacing {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

interface ISectionProps {
    variant?: SectionVariant;
    spacing?: SectionSpacing;
    className?: string;
}

export const Section: FunctionComponent<PropsWithChildren<ISectionProps>> = (props) => {
    const variant = props.variant ?? SectionVariant.White;
    const spacing = props.spacing ?? SectionSpacing.Large;

    const sectionClasses = mergeClasses(props.className, styles.section, styles[variant]);
    const innerClasses = mergeClasses(styles.sectionInner, styles[spacing]);

    return <section className={sectionClasses}>
        <PageWidth className={innerClasses}>
            {props.children}
        </PageWidth>
    </section>;
};
